module.exports = __webpack_public_path__ + "static/img/直播未开始.e72a380.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/直播未开始.png
// module id = 2v59
// module chunks = 1